import { Controller } from "@hotwired/stimulus"
import { app } from "theme/stimulus"

app.register(
  "gallery",
  class extends Controller {
    static values = { count: Number, index: { type: Number, default: 0 } }
    static targets = ["slide", "indicator", "scroller"]

    connect() {
      const scrollRoot = this.hasScrollerTarget ? this.scrollerTarget : this.element

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              const index = this.slideTargets.indexOf(entry.target)
              if (index !== -1) this.indexValue = index
            }
          })
        },
        { root: scrollRoot, threshold: 0.5 },
      )

      this.slideTargets.forEach((slide) => this.observer.observe(slide))
    }

    disconnect() {
      if (this.observer) this.observer.disconnect()
    }

    goTo(event) {
      const index = parseInt(event.currentTarget.dataset.index, 10)
      this.slideTargets[index]?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" })
    }

    indexValueChanged() {
      this.indicatorTargets.forEach((indicator, i) => {
        indicator.toggleAttribute("data-active", i === this.indexValue)
      })
    }
  },
)
